module.exports = __webpack_public_path__ + "img/slide_6.c1693241.webp";